// src/admin/adminNav.js
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import CampaignIcon from '@mui/icons-material/Campaign';
import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';
import StyleIcon from '@mui/icons-material/Style';
import ScienceIcon from '@mui/icons-material/Science';

// All Phase 1 items. `phase` is reserved for future Phase 2 entries; the
// layout currently renders every listed item as an active link.
export const ADMIN_NAV = [
  { label: 'Panoramica', path: '/admin', icon: DashboardIcon, end: true, phase: 1 },
  { label: 'Utenti', path: '/admin/users', icon: PeopleIcon, phase: 1 },
  { label: 'Richieste Pro', path: '/admin/requests', icon: HowToRegIcon, phase: 1 },
  { label: 'Archivio Use-Case', path: '/admin/use-cases', icon: ScienceIcon, phase: 1 },
  { label: 'Annunci', path: '/admin/announcements', icon: CampaignIcon, phase: 1 },
  { label: 'Audit Log', path: '/admin/audit', icon: HistoryIcon, phase: 1 },
  { label: 'Impostazioni', path: '/admin/settings', icon: SettingsIcon, phase: 1 },
  { label: 'Deck di carte', path: '/admin/deck', icon: StyleIcon, phase: 1 },
];
